import { render, staticRenderFns } from "./AbkSecondFooter.vue?vue&type=template&id=c07683d8&scoped=true&"
import script from "./AbkSecondFooter.vue?vue&type=script&lang=js&"
export * from "./AbkSecondFooter.vue?vue&type=script&lang=js&"
import style0 from "./AbkSecondFooter.vue?vue&type=style&index=0&id=c07683d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07683d8",
  null
  
)

export default component.exports